import { render } from "./CashboxTransactions.vue?vue&type=template&id=015aa075&scoped=true"
import script from "./CashboxTransactions.vue?vue&type=script&lang=js"
export * from "./CashboxTransactions.vue?vue&type=script&lang=js"

import "./CashboxTransactions.vue?vue&type=style&index=0&id=015aa075&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-015aa075"]])

export default __exports__